import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageGuestsComponent } from './sponsor/manage-guests/manage-guests.component';
import { CreateGuestComponent } from './sponsor/create-guest/create-guest.component';
import { AdminComponent } from './admin/admin.component';
import { EditGuestComponent } from './sponsor/edit-guest/edit-guest.component';
import { SponsorGuestTableComponent } from './admin/sponsor-guest-table/sponsor-guest-table.component';
import { SponsorGuard } from './shared/guards/sponsor.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { UnauthorizedPageComponent } from './shared/components/unauthorized-page/unauthorized-page.component';
import { AuthorizeGuard } from './shared';
import { LoginComponent } from './login.component';

const routes: Routes = [
  {
    path: 'sponsor',
    canActivate: [AuthorizeGuard, SponsorGuard],
    children: [
      { path: 'manage', component: ManageGuestsComponent },
      { path: 'manage/create', component: CreateGuestComponent },
      { path: 'manage/:guestRoleId', component: EditGuestComponent },
      { path: '', redirectTo: 'manage', pathMatch: 'prefix'}

    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sponsor'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'admin',
    canActivate: [AuthorizeGuard, AdminGuard],
    children: [
      { path: '', component: AdminComponent },
      { path: ':sponsorId/guests', component: SponsorGuestTableComponent }
    ]
  },
  {
    path: 'unauthorized',
    children:[
      { path: '', component: UnauthorizedPageComponent }
    ]
  },
  {
    path: '**',
    redirectTo: 'sponsor',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
